import { combineReducers, Reducer, AnyAction } from "redux";
import { DELETE_SESSION_SUCCESS } from "store/reducers/session/types";
import { RootState } from "store/types";
import externalApiCallLog from "store/reducers/external-api-call-log";
import session from "store/reducers/session";
import lodgingRequest from "store/reducers/lodgingRequest";
import lodgingOption from "store/reducers/lodgingOption";
import booking from 'store/reducers/booking';
import room from 'store/reducers/room';
import filter from 'store/reducers/filter'
import hotelInfo from 'store/reducers/hotelInfo';
import user from 'store/reducers/user';
import usersActivity from 'store/reducers/users-activity';
import lodgingPolicy from "store/reducers/lodgingPolicy";
import automatedReport from "store/reducers/automated-report";
import corporateClient from "store/reducers/corporate-client";
import occupancyInsights from "store/reducers/occupancy-insights";
import reservationProvider from "store/reducers/reservation-provider";
import modal from "store/reducers/newVersionModal"
import exportJobs from "store/reducers/export-jobs"
import guest from "store/reducers/guest"

const appReducer: Reducer<RootState> = combineReducers<RootState>({
  session,
  lodgingRequest,
  room,
  booking,
  lodgingOption,
  filter,
  modal,
  hotelInfo,
  user,
  usersActivity,
  lodgingPolicy,
  externalApiCallLog,
  automatedReport,
  corporateClient,
  occupancyInsights,
  reservationProvider,
  exportJobs,
  guest,
});

const rootReducer: Reducer<RootState> = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === DELETE_SESSION_SUCCESS) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
